/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2023-09-14 11:19:10
 * @LastEditTime: 2023-11-01 14:52:22
 * @LastEditors: WangYuhan
 */
import Layout from '@/layout';

const useOilRouter = {
  path: `/useOil`,
  component: Layout,
  redirect: `/useOil/wjy`,
  alwaysShow: true,
  name: 'useOil',
  meta: {
    id: 3,
    title: '用油管理',
    icon: 'yzs_youqiyewu',
    roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL', 'NORMAL_ZY'],
  },
  children: [
    {
      path: 'wjy',
      component: () => import('@/views/oil/wjy'),
      name: 'wjy',
      meta: {
        id: 31,
        title: '万金油',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL', 'NORMAL_ZY'],
      },
    },
    {
      path: 'bzy',
      component: () => import('@/views/oil/bzy'),
      name: 'bzy',
      pattern: 'account',
      meta: {
        id: 32,
        title: '八爪鱼',
        roles: ['SUPER_ADMIN', 'SUPER_FINANCE', 'NORMAL_FINANCE', 'NORMAL', 'NORMAL_ZY'],
      },
    },
  ],
};
export default useOilRouter;
